import { http } from "./http.js";

async function getArcticle(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    weightBrutto: response.data.WeightBrutto,
    weightNetto: response.data.WeightNetto,
    material: response.data.Material,
    dimensions: response.data.Dimensions,
    nomenclature: {
      id: response.data.Nomenclature.Id,
      title: response.data.Nomenclature.Title,
    },
    model: response.data.Model
      ? { id: response.data.Model.Id, title: response.data.Model.Title }
      : null,
    trademark: response.data.Trademark
      ? {
        id: response.data.Trademark.Id,
        title: response.data.Trademark.Title,
      }
      : null,
    manufacturer: response.data.Manufacturer
      ? {
        id: response.data.Manufacturer.Id,
        title: response.data.Manufacturer.Title,
      }
      : null,
    unit: response.data.Unit
      ? { id: response.data.Unit.Id, title: response.data.Unit.Title }
      : null,
    productCategory: response.data.ProductCategory
      ? {
        id: response.data.ProductCategory.Id,
        title: response.data.ProductCategory.Title,
      }
      : null,
    productSite: response.data.ProductSite ? response.data.ProductSite : "",
    country: response.data.Country
      ? {
        id: response.data.Country.Id,
        title: response.data.Country.Title,
        inputLanguage: response.data.Country.InputLanguage,
      }
      : null,
    category: response.data.Category
      ? {
        id: response.data.Category.Id,
        title: response.data.Category.Title,
      }
      : null,
    isRemoved: response.data.IsRemoved,
    date: response.data.Date,
    customsNumber: response.data.CustomsNumber,
  };
}

async function updateArticle(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response;
}

async function createArticle(resource, entity) {
  const response = await http.post(`/${resource}/`, entity);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}

async function trademarkChange(id) {
  const response = await http.get(`trademarks/${id}`);
  return response;
}

async function modelChange(id) {
  const response = await http.get(`trademark-models/${id}`);
  return response;
}

async function updateArticleСustomsNumber(id, customsNumber) {
  await http.patch(`articles/${id}/customs-number`, {
    value: customsNumber,
  });
}

async function updateModelTrademarkModel(id, trademarkModel) {
  await http.patch(`trademark-models/${id}/customs-number`, {
    value: trademarkModel,
  });
}

async function getArticle(id) {
  const response = await http.get(`/articles/${id}`);
  return response;
}

async function getModel(id) {
  const response = await http.get(`/trademark-models/${id}`);
  return response;
}

async function updateArticelProductCategory(id, productCategoryId) {
  await http.patch(`articles/${id}/product-category`, {
    value: productCategoryId,
  });
}

async function updateTrademarkProductCategory(id, productCategoryId) {
  await http.patch(`trademark-models/${id}/product-category`, {
    value: productCategoryId,
  });
}

async function updateTrademarkNomenclature(id, nomenclatureId) {
  await http.patch(`trademark-models/${id}/nomenclature`, {
    value: nomenclatureId,
  });
}

async function updateArticelNomenclature(id, nomenclatureId) {
  await http.patch(`articles/${id}/nomenclature`, {
    value: nomenclatureId,
  });
}

export {
  getArcticle,
  updateArticle,
  createArticle,
  changeRemovedState,
  trademarkChange,
  modelChange,
  updateArticleСustomsNumber,
  updateModelTrademarkModel,
  getArticle,
  getModel,
  updateArticelProductCategory,
  updateTrademarkProductCategory,
  updateTrademarkNomenclature,
  updateArticelNomenclature,
};
